/**
 * @func APM监控平台 - 听云
 * @Author zhangfs
 */
import router from '@/router';

try {
  if (window.MAIAAPM) {
    // 麦芽APM初始化
    if (window.MAIAAPM.init) {
      window.MAIAAPM.init({
        key: process.env.VUE_APP_APM_KEY,
        debug: process.env.VUE_APP_MODE !== 'prod'
      });
    } // VueRouter切换⾃动监控


    if (window.MAIAAPM.wrapVueRouter) {
      window.MAIAAPM.wrapVueRouter(router, {
        endDelay: 50 // 切换路由后延迟结束时间，关联路由加载之后⼀段时间内发起的请求

      });
    }
  }
} catch (error) {
  console.warn('MAIA_APM_INIT_ERROR:', error);
}